export enum PromotionAppliesTo {
  section = 0,
  assignment = 1,
  room_state = 2,
}
